import React, { useCallback } from 'react'
import '../../../assets/sass/components/Table/Index.scss'
import { TABLE } from '../../../constants/tables'
import * as styles from './table.module.scss'
import { TableProps } from './types'

const Table = ({
   totalCount,
   getTableProps,
   headerGroups,
   getTableBodyProps,
   page,
   prepareRow,
   rowAction,
   hideResultsTitle = false,
   isCart,
   tableType,
}: TableProps) => {
   const handleRowClick = useCallback(
      (e: MouseEvent, row: { original: any }) => {
         if (rowAction) {
            switch (tableType) {
               case 'Items': {
                  const { Id, ID, ToolLoanId, KitId, Warehouse } = row.original
                  return rowAction(
                     Id ?? ID,
                     ToolLoanId,
                     KitId,
                     Warehouse?.ToolWarehouseID
                  )
               }
               case 'Audits': {
                  const { AuditID } = row.original
                  return rowAction(AuditID, e)
               }
               case 'Audit Items': {
                  const {
                     Id,
                     ID,
                     ToolLoanId,
                     KitId,
                     Warehouse,
                     localUniqueId,
                     AuditItemID,
                  } = row.original
                  return rowAction(
                     Id ?? ID,
                     ToolLoanId,
                     KitId,
                     Warehouse?.ToolWarehouseID,
                     localUniqueId,
                     AuditItemID,
                     e
                  )
               }
               case 'Actions': {
                  const { Id, ID, ToolLoanId, KitId, Warehouse } = row.original
                  return rowAction(
                     Id ?? ID,
                     ToolLoanId,
                     KitId,
                     Warehouse?.ToolWarehouseID,
                     e
                  )
               }
               case 'Connections':
               case 'Locations': {
                  const { Id, ID } = row.original
                  return rowAction(Id ?? ID, e)
               }
               default:
                  return rowAction(
                     row.original.Id ?? row.original.ID,
                     row.original.ToolLoanId,
                     row.original.KitId,
                     e,
                     isCart,
                     row.original.localUniqueId,
                     row.original.AuditItemID
                  )
            }
         }
         return null
      },
      [rowAction, tableType, isCart]
   )

   return (
      <>
         {!hideResultsTitle && (
            <div className={styles.results}>
               {totalCount} {TABLE.COUNT_LABEL}
            </div>
         )}
         <div className="table-scroller">
            <table {...getTableProps()}>
               <thead>
                  {headerGroups.map((headerGroup) => (
                     <tr {...headerGroup.getHeaderGroupProps()}>
                        {headerGroup.headers.map((column) => {
                           return (
                              <th
                                 {...column.getHeaderProps({
                                    style: {
                                       textAlign: column.align ?? 'left',
                                       whiteSpace: 'nowrap',
                                       overflow: 'hidden',
                                       textOverflow: 'ellipsis',
                                    },
                                    width: column.minWidth ?? undefined,
                                 })}
                              >
                                 {column.render(TABLE.HEADER)}
                                 <div
                                    {...column.getResizerProps()}
                                    className={styles.resizer}
                                 />
                              </th>
                           )
                        })}
                     </tr>
                  ))}
               </thead>
               <tbody {...getTableBodyProps()}>
                  {page.map((row) => {
                     prepareRow(row)
                     return (
                        <tr
                           {...row.getRowProps()}
                           onClick={(e: MouseEvent) => handleRowClick(e, row)}
                           className={
                              rowAction ? styles.pointer : styles.noPointer
                           }
                        >
                           {row.cells.map((cell) => {
                              return (
                                 <td
                                    {...cell.getCellProps({
                                       style: {
                                          textAlign:
                                             cell.column.align ?? 'left',
                                          whiteSpace: 'nowrap',
                                       },
                                       width: cell.column.minWidth ?? undefined,
                                    })}
                                    className={cell.column.id}
                                 >
                                    {(!cell.column.allowBlank &&
                                       cell.value === '') ||
                                    cell.value === null ||
                                    cell.value === undefined
                                       ? '-'
                                       : cell.render(TABLE.CELL)}
                                 </td>
                              )
                           })}
                        </tr>
                     )
                  })}
               </tbody>
            </table>
         </div>
      </>
   )
}

export default Table
